/**
 * @desc 注册相关的接口
 */
export default {
  // 注册
  register: {
    url: '/mp/member/register',
    method: 'POST'
  },
  // 招商注册
  saveMerchantRegister: {
    url: '/mp/business/saveMerchantRegister',
    method: 'POST'
  }
};
